import { z } from 'zod'

export const notesQuerySchema = z.object({
  status: z.enum(['active', 'archived']).optional(),
})

export type NotesQueryInput = z.infer<typeof notesQuerySchema>
